import * as React from "react";
import { Button, Modal, Upload } from "antd";
import { readFile } from "@utils/readFile";
import { useRemoveUsersMutation } from "@graphql2/types";
import { useIntl } from "react-intl";

const DeleteUsersFromCsvButton = () => {
    const intl = useIntl();

    const [removeUsers, { loading }] = useRemoveUsersMutation({
        variables: {
            emails: [],
            anonymize: false
        }
    });
    async function handleUpload({ file }: { file: File; }) {
        const data = await readFile(file) as string;
        const [header, ...rows] = data.split(/\r?\n/).filter(o => o.length);
        const emailIndex = header.split(",").indexOf("email");
        const emails = rows.map((row:string) => {
            return row.split(",")[emailIndex];
        });

        Modal.confirm({
            width: 500,
            title: intl.formatMessage({ id: "users.removeByEmails.title" }),
            content: intl.formatMessage({ id: "users.removeByEmails.description" }, { count: emails.length }),
            okText: intl.formatMessage({ id: "continue" }),
            cancelText: intl.formatMessage({ id: "cancel" }),

            onOk: () => {
                removeUsers({
                    variables: {
                        emails,
                        anonymize: false
                    }
                }).then(() => {
                    Modal.info({
                        width: 500,
                        title: intl.formatMessage({ id: "users.removeByEmails.title" }),
                        content: intl.formatMessage({ id: "users.removeByEmails.progress" }, { time: (emails.length * 100) / 1000 })
                    });
                }).catch(() => {
                    Modal.error({
                        width: 500,
                        title: intl.formatMessage({ id: "users.removeByEmails.errorTitle" }),
                        content: intl.formatMessage({ id: "users.removeByEmails.error" })
                    });
                });
            }
        });
    }
    return (
        <Upload
            accept="application/csv"
            customRequest={handleUpload}
        >
            <Button
                danger
                className="headerUsersDeleteButton"
                loading={loading}
                type="dashed"
            >
                Delete from file
            </Button>
        </Upload>
    );
};

export default DeleteUsersFromCsvButton;

